import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { View } from 'react-native';
import { Button, Input } from 'react-native-elements';
import Autolink from 'react-native-autolink';
import { ifIphoneX } from 'react-native-iphone-x-helper';
import { fetchAuthSession } from '@aws-amplify/auth';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import { translate } from '../../../locales/i18n';
import AORTypes from '../../../types';
import styles from '../../../styles';

class PublisherToken extends React.Component {
  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherToken';

    this.onBack = this.onBack.bind(this);

    this.state = {
      token: '...',
    };
  }

  componentDidMount() {
    fetchAuthSession()
      .then(({ tokens }) => {
        console.log('tokens');
        console.log(tokens);
        this.setState({
          token: tokens.accessToken.toString(),
        });
      });
  }

  onBack() {
    const { history } = this.props;
    history.push('/publisherapps');
  }

  render() {
    const {
      user,
      history,
    } = this.props;

    const { token } = this.state;

    if (!user) {
      return (
        <>
        </>
      );
    }

    return (
      <View style={styles.view.headed}>
        <Button
          title={translate('button_back')}
          containerStyle={{
            ...ifIphoneX({
              alignSelf: 'center',
              paddingTop: 38,
            }, {
              alignSelf: 'flex-end',
              paddingTop: 8,
              paddingRight: 12,
            }),
          }}
          buttonStyle={styles.button.primary}
          disabledStyle={styles.button.primaryDisabled}
          titleStyle={styles.button.primaryTitle}
          disabledTitleStyle={styles.button.primaryTitleDisabled}
          onPress={() => {
            history.go(-1);
            // history.push(`/publisher/${user.attributes.sub}`);
          }}
        />

        <KeyboardAwareScrollView
          style={{
            margin: 10,
            marginTop: 30,
            width: '80%',
            alignSelf: 'center',
          }}
          contentContainerStyle={{
            alignItems: 'center',
          }}
        >
          <Autolink
            textProps={{
              style: {
                fontSize: 20,
              },
            }}
            text={translate('publisher_token_instructions')}
            linkStyle={{
              color: 'blue',
              fontSize: 20,
            }}
          />

          <Input
            value={token}
            readOnly
            multiline
            numberOfLines={16}
            containerStyle={{
              width: '100%',
              marginTop: 20,
            }}
            inputStyle={{
              fontSize: 16,
            }}
          />

          <Button
            title={translate('button_copy')}
            containerStyle={{
              ...ifIphoneX({
                alignSelf: 'center',
                paddingTop: 38,
              }, {
                alignSelf: 'center',
                paddingTop: 8,
                paddingRight: 12,
              }),
            }}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={() => {
              navigator.clipboard.writeText(token);
            }}
          />

        </KeyboardAwareScrollView>
      </View>
    );
  }
}

PublisherToken.defaultProps = {
  user: null,
};

PublisherToken.propTypes = {
  user: AORTypes.AWS.Cognito.User,
  history: ReactRouterPropTypes.history.isRequired,
};

export default PublisherToken;
